import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const ApplicationMaintenanceSupport = () => {
  return (
    <>
      <Helmet>
        <title>Application Maintenance & Support | Dhanam Infosys</title>
        <meta
          name="description"
          content="Ensure your applications are secure, reliable, and future-ready with our 24/7 AMS services. Preventive, corrective, and adaptive support for all tech stacks."
        />
      </Helmet>

      <NavBar />

      <div className="about-hero py-5 text-white text-center">
        <Container>
          <h1>Application Maintenance & Support (AMS)</h1>
          <p className="lead">Keep Your Applications Running Smoothly — Always</p>
        </Container>
      </div>

      <Container className="py-5">
        <p>
          At <strong>Dhanam Information Systems</strong>, we offer comprehensive Application Maintenance and Support (AMS) services designed to optimize performance, minimize downtime, and ensure business continuity. Our tailored delivery models — dedicated, shared, and offshore — serve a wide range of global clients.
        </p>

        <h5 className="text-primary mt-4 mb-3">🔹 Our AMS Offerings:</h5>
        <ul>
          <li><strong>Preventive Maintenance:</strong> Health checks, upgrades, and patching to avoid outages.</li>
          <li><strong>Corrective Maintenance:</strong> Bug resolution, performance fixes, and RCA.</li>
          <li><strong>Adaptive Maintenance:</strong> Updates based on evolving business needs.</li>
          <li><strong>Perfective Maintenance:</strong> Continuous improvements via feedback and audits.</li>
          <li><strong>24/7 Application Support:</strong> Global round-the-clock monitoring and incident handling.</li>
        </ul>

        <h5 className="text-primary mt-4 mb-3">🔹 Flexible Engagement Models:</h5>
        <ul>
          <li><strong>Dedicated AMS Teams:</strong> Exclusive teams assigned to your systems.</li>
          <li><strong>Shared Resource Model:</strong> Cost-effective expert support across projects.</li>
          <li><strong>Offshore/Remote Support:</strong> Global delivery at optimized costs and time zones.</li>
        </ul>

        <h5 className="text-primary mt-4 mb-3">🔹 Key Benefits:</h5>
        <ul>
          <li>Reduced operational costs with predictable SLAs</li>
          <li>Improved uptime and user satisfaction</li>
          <li>Quick incident response and change handling</li>
          <li>Expertise in legacy, cloud, and modern tech</li>
          <li>Seamless transition from in-house/vendor support</li>
        </ul>

        <Row className="my-5">
          <Col md={6}>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title className="text-success">📦 Brochure Snapshot</Card.Title>
                <ul>
                  <li>Preventive & corrective maintenance</li>
                  <li>Application monitoring & bug fixes</li>
                  <li>Enhancements & upgrades</li>
                  <li>SLA-based incident handling</li>
                  <li>Seamless offshore/onshore support</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="d-flex align-items-center">
            <div>
              <h5 className="fw-bold">Ensure application performance and resilience.</h5>
              <p>
                Choose Dhanam Information Systems for flexible and scalable AMS solutions tailored to your business needs.
              </p>
              <Button variant="primary" href="mailto:info@dhanaminfosys.com">
                📩 Contact Us
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />

      <style jsx>{`
        .about-hero {
          background-color: rgb(11, 22, 63);
        }

        ul {
          list-style: none;
          padding-left: 0;
        }

        ul li::before {
          margin-right: 10px;
          color: green;
        }
      `}</style>
    </>
  );
};

export default ApplicationMaintenanceSupport;
